import { Container, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { ForecastYears } from '../types';
import { WalletSummary } from '../utils/walletSummary';

type DividendProjectionChartProps = {
  summary: WalletSummary;
  years: ForecastYears;
};

/** Barras empilhadas de dividendos pagos, previstos e da meta: ano passado, atual e próximo. */
export function DividendProjectionChart({ summary, years }: DividendProjectionChartProps) {
  const paid = [summary.paidDividendLastYear, summary.paidDividend, 0];
  const projected = [0, summary.dividendStart, summary.dividendEnd];
  const goal = [summary.goalLastYear, summary.goalThisYear, summary.goalNextYear];
  const labels = [`${Number(years.start) - 1}`, years.start, years.end];

  return (
    <Container sx={{ padding: 0 }} maxWidth={"md"}>
      <Typography variant='h4' marginBottom={2}>
        Dividendos Projetados
      </Typography>
      <BarChart
        series={[
          { data: paid, stack: 'A', label: 'Pago', id: 'pvId' },
          { data: projected, stack: 'A', label: 'Previsto', id: 'uvId' },
          { data: goal, stack: 'A', label: 'Meta', id: 'gvId' },
        ]}
        barLabel={(item) => {
          if (!item.value) return null;
          return `R$${item.value?.toString()}`;
        }}
        xAxis={[{ data: labels, height: 28 }]}
        yAxis={[{ width: 50, tickLabelInterval: () => false, position: 'none' }]}
        height={400}
      />
    </Container>
  );
}
